import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@auth-n/authentication.service';

/**
 * Standalone component mounted on the /logout route.
 * Performs a full sign-out and redirects to the sign-in page.
 *
 * Replaces the previous LogoutRouteGuard approach which fired
 * signOutAndRedirect as a fire-and-forget side-effect, allowing
 * concurrent auth checks to race and re-authenticate the user.
 */
@Component({
  selector: 'app-logout',
  standalone: true,
  template: ''
})
export class LogoutComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    console.log('LOGOUT COMPONENT: ngOnInit fired, calling signOutAndRedirect. href:', window.location.href);
    this.authenticationService.signOutAndRedirect();
  }
}
